import { usePageTitle } from '@/hooks/usePageTitle';
import DocsAndFilesPage from './DocsAndFilesPage';

// Global Docs page - shows company-wide documents view
// This wraps DocsAndFilesPage with isGlobalView flag to display all spaces' documents
export function GlobalDocsPage() {
  usePageTitle('Documents');
  return <DocsAndFilesPage isGlobalView={true} />;
}

export default GlobalDocsPage;
